import { Header } from "@/components/shared";
import { Outlet } from "react-router-dom";

function MainLayout() {
  return (
    <div className="fixed flex w-screen flex-col h-dvh">
      <Header />
      <div className="flex flex-col grow shrink">
        <Outlet />
      </div>
    </div>
  );
}

export default MainLayout;
